import { CardLoader, ListPagination } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import FastSellProductTableRow from './fast-sell-product-table-row'

const propTypes = {
  tableProps       : PropTypes.object,
  fastSellProducts : PropTypes.array,
  pagination       : PropTypes.object,
  onPageChange     : PropTypes.func,
  isLoading        : PropTypes.bool,
  to               : PropTypes.func
}

const defaultProps = {
  isLoading    : true,
  onPageChange : () => { },
  to           : () => { }
}

/**
 * Table to display specific ::FastSellProduct columns
 * @param {Object} tableProps - object of tableProps that contains size, responsive, etc
 * @param {Array<Object>} fastSellProducts - array of fast sell product objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Boolean} isLoading - boolean for withLoader animation
 * @param {Function} onPageChange - function that will handle page change
 * @param {String} to - Link to navigate if user click on button
 */


const FastSellProductTable = ({
  tableProps,
  fastSellProducts,
  pagination,
  isLoading,
  onPageChange,
  to
}) => {

  const totalColumns           = 12
  const isFastSellProductEmpty = fastSellProducts.length === 0

  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <tr>
          <th colSpan={ totalColumns } className='text-center'>
            { 'Fast Sell Products' }
          </th>
        </tr>
        <tr>
          <th scope="col">id</th>
          <th scope="col">nama product</th>
          <th scope="col">brand</th>
          <th scope="col">kategori</th>
          <th scope="col">kondisi</th>
          <th scope="col">serial code</th>
          <th scope="col">tahun pembelian</th>
          <th scope="col">penawaran awal</th>
          <th scope="col">status</th>
          <th scope="col">received status</th>
          <th scope="col">nama seller</th>
          <th scope="col">action</th>
        </tr>
      </thead>
      <tbody>
        {
          fastSellProducts.map((fastSellProduct) => (
            <FastSellProductTableRow
              key={ `FastSellProduct-${fastSellProduct.id}` }
              fastSellProduct={ fastSellProduct }
              to={ to }
            />
          ))
        }
        {
          isFastSellProductEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'Fast Sell Product tidak ditemukan.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <ListPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}


FastSellProductTable.propTypes    = propTypes
FastSellProductTable.defaultProps = defaultProps

export default FastSellProductTable